import { getParamsFormObject } from 'utils';
import axiosClient from 'utils/axios';

export default {
  async getBankingList(payload) {
    const params = getParamsFormObject(payload);
    const path = `/bankings${params}`;

    const response = await axiosClient.get(path);

    return response.data;
  },

  async addBankingOfPlace({ placeId, data }) {
    const path = `/bankings?place=${placeId}`;

    await axiosClient.post(path, data);
  },

  async updateBankingOfPlace({ bankAccount, placeId, data }) {
    const path = `/bankings/${bankAccount}?place=${placeId}`;

    await axiosClient.put(path, data);
  },

  async requestUpdateBankingOfPlace(data) {
    const path = '/bankings/bank-account-requests';

    await axiosClient.post(path, data);
  },
};
